module.exports = __webpack_public_path__ + "static/DightyConnect-e3fec5000ea7fa123b913c9cfce4046f.jpg";